import { AdminMicrostories } from '@platform/client';
import { Modal } from '@platform/components';
import { useQueryClient } from '@tanstack/react-query';

interface DeleteMicrostoryModalProps {
  isOpen: boolean;
  onClose: () => void;
  id: number;
}

export const DeleteMicrostoryModal = (props: DeleteMicrostoryModalProps) => {
  const { isOpen, onClose, id } = props;

  const queryClient = useQueryClient();

  const deleteMicrostoryMutator = AdminMicrostories.useDeleteMicrostory({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: AdminMicrostories.getGetAdminMicrostoriesQueryKey(),
        });
      },
    },
  });

  const deleteMicrostory = () => {
    deleteMicrostoryMutator.mutate({ data: { id } });
    onClose();
  };

  return (
    <Modal
      variant='dialog'
      title='Delete Microstory'
      ignoreExtraPadding={true}
      isOpen={isOpen}
      headerDivision='divider'
      onClose={onClose}
      primaryCTA={{
        text: 'Delete Microstory',
        callback: deleteMicrostory,
      }}
      secondaryCTA={{
        text: 'Cancel',
        callback: onClose,
      }}
    >
      <div className='md:w-[460px]'>
        <div className='flex flex-col gap-4 w-full'>
          Are you sure you want to delete this microstory?
        </div>
      </div>
    </Modal>
  );
};
